module.exports = __webpack_public_path__ + "img/mono_2.b8298749.png";